import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";

interface ManagedHub {
  id: string;
  role: string;
  choiceBoardsEnabled: boolean;
}

function useManagedHubs(enabled: boolean) {
  return useQuery<ManagedHub[]>({
    queryKey: ["/api/hubs/managed"],
    queryFn: () => apiRequest<ManagedHub[]>("/api/hubs/managed"),
    enabled,
  });
}

export function useHubRole(hubId?: string, enabled = true): string | undefined {
  const hubsQuery = useManagedHubs(enabled && Boolean(hubId));

  return hubsQuery.data?.find((hub) => hub.id === hubId)?.role;
}

export function useHubChoiceBoardsAccess(hubId?: string, enabled = true) {
  const hubsQuery = useManagedHubs(enabled && Boolean(hubId));
  const hub = hubsQuery.data?.find((managedHub) => managedHub.id === hubId);

  return {
    canAccess: hub?.choiceBoardsEnabled === true,
    isLoading: Boolean(hubId) && hubsQuery.isLoading,
  };
}